import React from 'react';
import './EventSection.css';
import EventGrid from './EventGrid';
import CreateEventForm from './CreateEventForm';
import EventDetailsModal from './EventDetailsModal';

const EventSection = ({
  isCreatingEvent,
  setIsCreatingEvent,
  selectedEvent,
  setSelectedEvent,
  allEvents,
  eventAttendance,
  handleAttendEvent,
  handleLeaveEvent,
  handleCreateEvent,
  handleEditEvent,
  handleCancelEvent,
  handleShareEvent,
  newEvent,
  setNewEvent,
  handleEventInputChange,
  currentUser,
  eventAttendees
}) => (
  <div className="event-section">
    {/* Event Section Header */}
    <div className="event-section-header">
      <h2 className="event-section-title">Upcoming Language Events</h2>
      
      {/* Create Event Button */}
      {!isCreatingEvent && (
        <button
          className="create-event-btn"
          onClick={() => setIsCreatingEvent(true)}
        >
          + Create Event
        </button>
      )}
    </div>

    {/* Create Event Form */}
    {isCreatingEvent && (
      <CreateEventForm
        newEvent={newEvent}
        setNewEvent={setNewEvent}
        handleEventInputChange={handleEventInputChange}
        handleCreateEvent={handleCreateEvent}
        setIsCreatingEvent={setIsCreatingEvent}
      />
    )}

    {/* Event Details Modal */}
    {selectedEvent && (
      <EventDetailsModal
        event={selectedEvent}
        isAttending={eventAttendance[selectedEvent.id]}
        onClose={() => setSelectedEvent(null)}
        onAttend={handleAttendEvent}
        onLeave={handleLeaveEvent}
        onEdit={handleEditEvent}
        onCancel={handleCancelEvent}
        onShare={handleShareEvent}
        isCreator={selectedEvent.created_by === currentUser?.id}
        attendees={eventAttendees[selectedEvent.id] || []}
      />
    )}

    {/* Modular Event Grid */}
    <EventGrid
      allEvents={allEvents}
      eventAttendance={eventAttendance}
      setSelectedEvent={setSelectedEvent}
      handleAttendEvent={handleAttendEvent}
      currentUser={currentUser}
    />
  </div>
);

export default EventSection;


